module.exports = __webpack_public_path__ + "static/src/content/images/processed/400/Drone.2cb45ed.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/processed/400/Drone.jpg
// module id = bMK3
// module chunks = 0